import React from 'react'
import { CSSTransition, SwitchTransition } from 'react-transition-group'
import { BATH, MAIN } from '../../constants/localStates'
import { mainContent } from '../../../../../constants/copyright'
import { INTERACTIVE_SHOP } from '../../../../../constants/shared/states/names'
import { useContent } from '../../../../../redux/reducer/content'
import classNames from 'classnames'
import CustomButton from '../../../../features/customButton/ui/main/CustomButton'
import useStateControls from '../../../../../hooks/useStateControls'
import { GTMBath, gtmFunctions } from '../../../../../constants/analytics/GTM'
import { useApplicationCallbacks } from '../../../../../providers/application-callbacks'
import { useBeautyRedirect } from '../../../../../hooks/useBeautyRedirect'
import { useSetBackground } from '../../../interactiveShop'

const { interactiveShop } = mainContent

export default function MainToShopButton() {
  const { isBath } = useContent()
  const localState = isBath ? BATH : MAIN
  const setBackground = useSetBackground()
  const { setState } = useStateControls()

  const callbacks = useApplicationCallbacks()
  const onClick = () => {
    const stateCallbacks = {
      [BATH]() {
        gtmFunctions.GTMBeautyRoutine()
        callbacks.getBeautyRoutine()
      },
      async [MAIN]() {
        GTMBath()
        await setBackground()
        setState(INTERACTIVE_SHOP)
      },
    }

    stateCallbacks[localState]?.()
  }

  useBeautyRedirect()

  if (localState === MAIN) {
    return null
  }

  return (
    <SwitchTransition>
      <CSSTransition
        appear={true}
        key={localState}
        timeout={300}
      >
        <div
          className={classNames('main__procedure-label', {
            'main__procedure-label_to-main': localState === BATH,
            'main__procedure-label_to-bath': localState === MAIN,
          })}
        >
          <CustomButton
            {...interactiveShop.attr}
            newFlagData={localState === BATH && interactiveShop.newFlagData}
            icon={`buttons/${{ [BATH]: 'to-procedure', [MAIN]: 'to-store' }[localState]}`}
            onClick={onClick}
          >
            <div
              className={'main__bathroom-tutor'}
              data-tutor-id={localState === BATH ? 'to-bath' : undefined}
            />
          </CustomButton>
        </div>
      </CSSTransition>
    </SwitchTransition>
  )
}
